
import React from 'react';
import { Input } from '@/components/ui/input';
import { AlertCircle, Eye, EyeOff } from 'lucide-react';

interface PasswordInputProps {
  password: string;
  setPassword: (password: string) => void;
  showPassword: boolean;
  togglePasswordVisibility: () => void;
  passwordError: string;
  resetPasswordError: () => void;
}

const PasswordInput = ({ 
  password, 
  setPassword, 
  showPassword, 
  togglePasswordVisibility, 
  passwordError, 
  resetPasswordError 
}: PasswordInputProps) => {
  return (
    <div className="space-y-2">
      <div className="relative">
        <Input
          type={showPassword ? "text" : "password"}
          placeholder="Password"
          value={password}
          onChange={(e) => {
            setPassword(e.target.value);
            resetPasswordError();
          }}
          required
          className={`pr-10 ${passwordError ? 'border-red-500' : ''}`}
        />
        <button
          type="button"
          onClick={togglePasswordVisibility}
          className="absolute right-3 top-2.5 text-gray-500 hover:text-gray-700"
          aria-label={showPassword ? "Hide password" : "Show password"}
        >
          {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
        </button>
      </div>
      {passwordError && (
        <div className="text-red-500 text-sm flex items-center mt-1">
          <AlertCircle size={14} className="mr-1" />
          {passwordError}
        </div>
      )}
    </div>
  );
};

export default PasswordInput;
